import React from "react";

interface TabsProps<T> {
  options: {
    label: string;
    value: T;
  }[];
  value: T;
  onChange: (value: T) => void;
}

export const Tabs = <T extends string>(props: TabsProps<T>) => {
  const { options, value, onChange } = props;
  const activeIndex = options.findIndex(option => option.value === value);

  return <div className="tabs-wrapper">
    <div
      className="tabs-indicator"
      style={{
        transform: `translateX(${activeIndex * 100}%)`,
        width: `calc(${100 / options.length}% - ${16 / options.length}px)`,
      }}
    />

    {options.map((option, index) => (
      <button
        key={option.value}
        className={`tabs-tab ${activeIndex === index ? "tab-active" : ""}`}
        onClick={() => onChange(option.value)}
        style={{
          width: `${100 / options.length}%`,
        }}
      >
        {option.label}
      </button>
    ))}
  </div>
}